import Template from '../../component/Template.js';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';


export default function Faculty() {
  const [message, setMessage] = useState(false);
  const [discipline, setDisciplineData] = useState([]);
  const [faculty, setFacultyData] = useState([]);
  const [specialization, setSpecialization] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [facultyname,setFacultyname] = useState(false);
  const status = "active";
  const { http } = Api();
 
  const [errors, setErrors] = useState({spec_name: '', dname: '',fac: '' }); //20/3/2024 for validation

  const navigate = useNavigate();

  useEffect(() => {
      const { http } = Api();
      const id1 = sessionStorage.getItem("id");

      const fetchData = async () => {
          try {

              const response = await http.get(`/Admin/getspecialisation`);
              const response1 = await http.get(`/Admin/getfaculty`);
              const response2 = await http.get(`/Admin/getdiscipline`, {
                params: {
                  limit: '500'
                }
              });

              setDisciplineData(response2.data.data);
              setFacultyData(response1.data.data);
              setSpecialization(response.data.specialization)
              console.log(response1);

          } catch (error) {

              setMessage("somthing went wrong");
              console.error('Error fetching discipline data:', error);

          }
      };

      fetchData();

  }, []);


  const isAuth = useAuth();
  
  if (isAuth === false) {
    navigate("/admin/")
  }

  //used to find the discipline based on faculty
  const isdisiplin = () => {
      const faculty_id = document.getElementById('faculty_id').value;
      const selectedFaculty = faculty.find(facultys => parseInt(facultys.id) === parseInt(faculty_id));
      setFacultyname(selectedFaculty.faculty_name);
    
  }


  const validateForm = () => {

    const updatedErrors = {};
    let hasError = false;

    const specialization = document.getElementById('specialization').value;
    const discipline_id = document.getElementById('discipline_id').value;
    const faculty_id = document.getElementById('faculty_id').value;

    if (!specialization) {

      updatedErrors.spec_name = 'Please enter a Specialization';
      hasError = true;     

    }
    if (!discipline_id) {

      updatedErrors.dname = 'Please select a Discipline';
      hasError = true;   

    }
    if (!faculty_id) {
      updatedErrors.fac = 'Please select a Faculty';
      hasError = true; 

    }
    if (hasError) 
    {
      setErrors(updatedErrors);
      if (!specialization) {
          document.getElementById('specialization').focus();
      } else if (!discipline_id) {
          document.getElementById('discipline_id').focus();
      } else if (!faculty_id) {
        document.getElementById('faculty_id').focus();
      }
      return false;
   } else {
      setErrors({ spec_name: '', dname: '',fac: '' });
      return true;
   }

  };



  const cancelForm = () => {
      navigate("/admin/specialization");
  };

  const saveForm = () => {


      if (validateForm()) {


          const specialization = document.getElementById('specialization').value;
          const discipline_id = document.getElementById('discipline_id').value;
          const faculty_id = document.getElementById('faculty_id').value;
          const remarks = document.getElementById('remarks').value;
         
          const remarksValue = remarks ? remarks : "Null";

          console.log(specialization,discipline_id,faculty_id,status,remarksValue);
          // faculty_id:faculty_id,
          http.post(`/Admin/savespecialisation`, { faculty_id:faculty_id,discipline_id: discipline_id, specialisation_name: specialization, remarks: remarksValue, status: status })
              .then(response => {
                  console.log(response);

                  if (response.data.status_code === "MSG1") {
                      sessionStorage.setItem("message", "specialization is added successfully");
                      navigate("/admin/specialization");

                  }
              })
              .catch(error => {
                  console.error(error);


                  if (error.response && error.response.status === 500) {
                      setMessage("Duplicate Value: This faculty already exists");
                  } else {
                      setMessage("Something Went Wrong");
                  }

              });
      }
  };


  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12" >
              <div className="card">                
                <div className="col-md-12">
                  <div className="card-header"> 
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Add Specialization</h5>
                    </div>
                  </div>
                  <div className="card-body">
                  {message && (
                                                <div className="alert alert-danger mar2" role="alert">
                                                    <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                                                </div>
                                            )}
                    <div className="card-body pdg">
                      <div className="table-responsive">


                       
                          <div className="card-body custom-input">
                          
                            <div className="row">
                              <div className="col">
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Specialization <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                    <input className="form-control input-air-primary" type="text" id="specialization" name="specialization" onChange={(e) => setSpecialization(e.target.value)} placeholder="Specialization" maxLength={3}/>
                                    {errors.spec_name && <p className="text-danger">{errors.spec_name}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Faculty Name <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                  <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" onChange={isdisiplin} required>
                                        <option value="" >Select Faculty</option>

                                        {faculty.map(facultys => (

                                            <option value={facultys.id}  >{facultys.faculty_name}</option>
                                        ))}

                                    </select>
                                    {errors.fac && <p className="text-danger">{errors.fac}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Discipline <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                  <select className="form-control form-select scrollable-bar-select" id="discipline_id" name="discipline_id" required>
                                            <option value="">Select Discipline</option>
                                            {discipline.map(disciplines => (
                                                disciplines.faculty_name === facultyname && (
                                                    <option key={disciplines.id} value={disciplines.id}>{disciplines.discipline_name}</option>
                                                )
                                            ))}
                                        </select>
                                        {errors.dname && <p className="text-danger">{errors.dname}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Remarks</label>
                                  <div className="col-sm-9">
                                    <textarea className="form-control input-air-primary" id="remarks" name="remarks" placeholder="Remarks" onChange={(e) => setRemarks(e.target.value)} />
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          
                            <div className="col-md-12 txt-aln">
                              <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                              <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                            </div>
                          
                       



                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Template>
    </>
  );
}
